import styled from "styled-components";
import {AccountCircle, Layers, Work, Edit} from "@mui/icons-material";
import {CameraAlt} from "@mui/icons-material";
import {StyledButton} from "../../../components/Buttons/DefaultButton/DefaultButton.styles"

export const PhotoBox = styled.div`
    display: flex;
    align-self: center;
    flex-direction: column !important;

    .nameBox {
        margin-top: 0.5rem;
        color: var(--text-primary, rgba(0, 0, 0, 0.87));
        text-align: center;
        font-feature-settings: 'clig' off, 'liga' off;
        font-size: 1.5rem;
        font-style: normal;
        font-weight: 600;
        line-height: 133.4%;
    }

    .photoImg {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .profile-photo-parent {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        font-size: var(--typography-body2-size);
        border-radius: 50%;
        border: 2px dashed rgba(0, 0, 0, 0.12);
        box-sizing: border-box;
        width: 8rem;
        height: 8rem;
        justify-content: center;
        gap: 0.63rem;
        align-self: center;
        overflow: auto;
    }

    .profile-photo-parent:hover {
        opacity: 0.2;
    }
`

export const CameraIcon = styled(CameraAlt)`
    height: 4rem !important;
    width: 4rem !important;
    fill: #FB7672 !important;
    display: flex;
    align-self: center;
`;

export const HeaderDescription = styled.h2`
    color: var(--text-secondary, rgba(0, 0, 0, 0.60));
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;

    font-size: 1rem;
    letter-spacing: 0.15px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 30px */
`

export const InputBlock = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;

    div {
        width: 100%;
    };

    @media only screen and (max-width: 400px) {
        flex-direction: column;
    }
`

const SectionBox = styled.div`
    display: flex;
    padding: var(--2, 16px);
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 10px;
    align-self: stretch;

    border-radius: var(--2, 16px);

    .roundedBoxDescription {
        white-space: pre-wrap;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        display: -webkit-box;
    }
`

export const SectionTitle = styled.div`
    color: var(--text-primary, rgba(0, 0, 0, 0.87));
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
    letter-spacing: 0.15px;

    display: flex;
    justify-content: space-between;
    width: 100%;
    
    div {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }
`

export const AboutYouBox = styled(SectionBox)`
    background: var(--background-main, #FFF4F4);
`

export const QualificationBox = styled(SectionBox)`
    background: var(--background-success, #F1F7FF);
`

export const ExperienceBox = styled(SectionBox)`
    background: var(--background-alternate, #FFFAF6);
`

export const AccountCircleFilledIcon = styled(AccountCircle)`
    color: var(--primary-main);
    width: var(--3, 24px);
    height: var(--3, 24px);
`

export const LayersFilledIcon = styled(Layers)`
    color: var(--secondary-main);
    width: var(--3, 24px);
    height: var(--3, 24px);
`

export const WorkFilledIcon = styled(Work)`
    color: var(--warning-main);
    width: var(--3, 24px);
    height: var(--3, 24px);
`

export const EditFilledIcon = styled(Edit)`
    width: 18px;
    height: 18px;
`